export default "__VITE_ASSET__1fe89ddb__"